var _CreditCardImgUrlMap;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React, { useEffect, useCallback } from 'react';
import { Card, Title3 } from '../../styled';
import { SLRadio as Radio } from '@yy/sl-admin-components';
import { ListPanel, RadioItem, Icon, ContentWrap, ImgCardList, ImgCardItem, ChangeBtn, LastNum, FooterWrap } from './styled';
import { useTranslation } from '../../_utils/i18n';
import withI18nAndTheme from '../../_utils/withI18nAndTheme';
import { usePayMethod, useCardListState, useDisabledPay, useCompatibleForSentry } from '../../hooks';
import { EBindStatus, EPayMethodType, RadioPayMethod, CreditCardImg } from '../../constants';
import ChangeCreditCardModal from '../ChangeCreditCardModal';
import PayWithFPX from '../PayWithFPX';
import PayWithXendit from '../PayWithXendit';
import { useConfigAtomValues, useStateAtom } from '../../state';
import weixinUrl from './images/weixin.svg';
import CreditCardUrl from './images/creditCard.svg';
import visaImgUrl from './images/visa.svg';
import masterImgUrl from './images/master.svg';
import jcbImgUrl from './images/jcb.svg';
import amexImgUrl from './images/amex.svg';
import unionPayImgUrl from './images/unionPay.svg';
import alipayCN from './images/alipayCN.svg';
import unionPayInterUrl from './images/unionPayInternational.svg';
import fpxPayUrl from './images/FPX.svg';
import xenditPayUrl from './images/xendit.svg';
import walletUrl from './images/wallet.svg';
import payNowUrl from './images/payNow.svg';
import umsIconUrl from './images/ums.svg';
import payPalUrl from './images/paypalAvatar.svg';
import { getPayMethodByCardChannel } from '../../_utils/tool';
import useDefaultPayMethod from '../../hooks/useDefaultPayMethod';
var defaultCreditCardImgList = [CreditCardImg.Visa, CreditCardImg.Master, CreditCardImg.Amex];
var CreditCardImgUrlMap = (_CreditCardImgUrlMap = {}, _defineProperty(_CreditCardImgUrlMap, CreditCardImg.Visa, visaImgUrl), _defineProperty(_CreditCardImgUrlMap, CreditCardImg.Master, masterImgUrl), _defineProperty(_CreditCardImgUrlMap, CreditCardImg.JCB, jcbImgUrl), _defineProperty(_CreditCardImgUrlMap, CreditCardImg.Amex, amexImgUrl), _defineProperty(_CreditCardImgUrlMap, CreditCardImg.UnionPay, unionPayImgUrl), _CreditCardImgUrlMap);
var AirwallexCardList = [{
  type: 'visa',
  imgUrl: visaImgUrl
}, {
  type: 'master',
  imgUrl: masterImgUrl
}, {
  type: 'unionPay',
  imgUrl: unionPayImgUrl
}];
var PayMethodCrad = function PayMethodCrad(props) {
  var cardTitle = props.cardTitle,
    footer = props.footer;
  var _useConfigAtomValues = useConfigAtomValues(),
    payChannelList = _useConfigAtomValues.payChannelList,
    FPXNode = _useConfigAtomValues.FPXNode,
    bizCreditCardImgList = _useConfigAtomValues.bizCreditCardImgList;
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    _useStateAtom2$ = _useStateAtom2[0],
    selectCard = _useStateAtom2$.selectCard,
    radioPayMethod = _useStateAtom2$.radioPayMethod,
    setStateAtom = _useStateAtom2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  /** 将传入的sentry实例同步到jotai */
  useCompatibleForSentry(props);

  // 当账单为已取消或已成功支付、或正在支付中时，账单不可支付
  var disabledPay = useDisabledPay();
  var renderCreditCardImgList = bizCreditCardImgList !== null && bizCreditCardImgList !== void 0 && bizCreditCardImgList.length ? bizCreditCardImgList : defaultCreditCardImgList;
  var useCardListStateReturns = useCardListState();
  var request = useCardListStateReturns.request,
    getAllCardList = useCardListStateReturns.getAllCardList;
  var cardList = getAllCardList();
  var _usePayMethod = usePayMethod(cardList),
    onPayMethodChange = _usePayMethod.onPayMethodChange;
  var markDefaultCard = function markDefaultCard() {
    // 绑卡列表数据请求回来之后再标记默认卡
    if (!request.loading && cardList.length > 0) {
      // 卡的绑定状态是否正常
      var isCardStatusNormal = function isCardStatusNormal(bindStatus) {
        return [EBindStatus.SUCCEEDED].includes(bindStatus);
      };
      var defaultItem = cardList.find(function (item) {
        return item.defaultCard && isCardStatusNormal(item.bindStatus);
      });
      setStateAtom(function (draft) {
        draft.selectCard = defaultItem || cardList[0];
      });
    }
  };
  useEffect(function () {
    markDefaultCard();
  }, [request.loading]);
  useEffect(function () {
    var eleTitle = document.getElementById('xendit__option--title');
    var eleGroup = document.getElementById('xendit_group');
    if (!payChannelList) return;
    if (!document.getElementById('xendit_group')) return;
    if (!document.getElementById('xendit_group').parentNode) return;
    var condition = payChannelList.find(function (item) {
      return item.payMethod === EPayMethodType.XENDIT;
    });
    if (!condition) return;
    if (!document.getElementById('xendit__option')) return;
    if (!document.getElementById('xendit__option').parentNode) return;
    if (!document.getElementById('xendit__option').parentNode.parentNode) return;

    // 监听title变化 => 因为多语言加载会导致这个元素有默认值再变为真正的值，下拉框必须要动态监听这个变化
    new ResizeObserver(function (entries) {
      // 初始化变量
      if (!document.getElementById('xendit__option')) return;
      if (!document.getElementById('xendit__option').parentNode) return;
      var xenditOption = document.getElementById('xendit__option').parentNode.parentNode;
      var xenditBox = document.getElementById('xendit__box');
      document.getElementById('xendit_group').parentNode.style.position = 'relative';

      // 初始化自定义盒子定位
      xenditBox.style.position = 'absolute';
      var offsetTop = xenditOption.offsetTop;
      if (document.getElementById('xendit_group').clientWidth > 492) {
        xenditOption.style.height = '54px';
        xenditBox.style.top = offsetTop + 'px';
        var lenth = document.getElementById('xendit__option--title').clientWidth + 30;
        xenditBox.style.left = lenth + 78 + 'px';
      } else {
        xenditOption.style.height = '78px';
        xenditBox.style.top = offsetTop + 30 + 'px';
        xenditBox.style.left = '100px';
      }
    }).observe(eleTitle);

    // 监听group变化 => 测试反馈交互需要跟FPX对齐，具备最小窗口时下拉框下移
    new ResizeObserver(function (entries) {
      var entry = entries[0];
      var cr = entry.contentRect;
      // 初始化变量
      if (!document.getElementById('xendit__option')) return;
      if (!document.getElementById('xendit__option').parentNode) return;
      var xenditOption = document.getElementById('xendit__option').parentNode.parentNode;
      var xenditBox = document.getElementById('xendit__box');
      document.getElementById('xendit_group').parentNode.style.position = 'relative';

      // 初始化自定义盒子定位
      xenditBox.style.position = 'absolute';
      var offsetTop = xenditOption.offsetTop;
      if (cr.width > 666) {
        xenditOption.style.height = '54px';
        xenditBox.style.top = offsetTop + 'px';
        var lenth = document.getElementById('xendit__option--title').clientWidth + 30;
        xenditBox.style.left = lenth + 78 + 'px';
      } else {
        xenditOption.style.height = '78px';
        xenditBox.style.top = offsetTop + 30 + 'px';
        xenditBox.style.left = '100px';
      }
    }).observe(eleGroup);
  }, [payChannelList]);
  var handleDefaultPayMethod = function handleDefaultPayMethod(payMethod, radioPayMethod) {
    setStateAtom(function (draft) {
      draft.payMethod = payMethod;
      draft.radioPayMethod = radioPayMethod;
    });
  };
  useDefaultPayMethod({
    payChannelList: payChannelList,
    cardList: cardList,
    selectCard: selectCard,
    onDefaultPayMethod: handleDefaultPayMethod
  });
  var onRadioChange = useCallback(function (e) {
    var radioPayMethod = e.target.value;
    var payMethod = radioPayMethod;
    // 当选择了 「银行卡支付」
    if (radioPayMethod === RadioPayMethod.BankCard) {
      // 确认当前选择了哪个支付渠道的银行卡
      var payChannel = selectCard.payChannel;
      var value = getPayMethodByCardChannel(payChannel);
      payMethod = value;
    }
    var param = {
      target: {
        value: payMethod
      }
    };
    onPayMethodChange(param);
    setStateAtom(function (draft) {
      draft.radioPayMethod = radioPayMethod;
    });
  }, [onPayMethodChange, selectCard, setStateAtom]);
  return /*#__PURE__*/React.createElement(Card, {
    className: disabledPay ? 'cardDisabled' : '',
    style: {
      paddingTop: 19,
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Title3, null, cardTitle ? cardTitle : t('settlement.payway')), /*#__PURE__*/React.createElement(ListPanel, null, /*#__PURE__*/React.createElement(Radio.Group, {
    id: "xendit_group",
    value: radioPayMethod,
    onChange: onRadioChange
  }, cardList.length > 0 && /*#__PURE__*/React.createElement(RadioItem, {
    value: RadioPayMethod.BankCard,
    key: RadioPayMethod.BankCard
  }, /*#__PURE__*/React.createElement(Icon, {
    url: CreditCardUrl
  }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
    style: {
      marginRight: 12,
      marginTop: 8
    }
  }, t('settlement.payway.credit card')), selectCard ? /*#__PURE__*/React.createElement(LastNum, null, t('settlement.tail number2', {
    lastNum: selectCard.last
  }), t('settlement.selectbox.credit card')) : null), (cardList === null || cardList === void 0 ? void 0 : cardList.length) > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeBtn, {
    onClick: function onClick() {
      setStateAtom(function (draft) {
        draft.changeCardModalVisible = true;
      });
    }
  }, t('settlement.switch credit card')), /*#__PURE__*/React.createElement(ChangeCreditCardModal, null)) : null)), payChannelList === null || payChannelList === void 0 ? void 0 : payChannelList.map(function (item) {
    // 如果 channelId 在预设表中存在则渲染
    switch (item.payMethod) {
      case EPayMethodType.Wechat:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.Wechat,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: weixinUrl
          }), /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginTop: 8
            }
          }, t('settlement.payway.Wechat pay')));
        }
      // 国际卡绑定并支付类型
      case EPayMethodType.Creditcard:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.BindInternationalCard,
            key: item.payMethod,
            disabled: item.disabled,
            "data-sl-fk": item.fk
          }, /*#__PURE__*/React.createElement(Icon, {
            url: CreditCardUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, t('settlement.payway.InternationalCardbindandpay')), /*#__PURE__*/React.createElement(ImgCardList, null, renderCreditCardImgList.map(function (item) {
            return /*#__PURE__*/React.createElement(ImgCardItem, {
              key: item,
              url: CreditCardImgUrlMap[item]
            });
          })))));
        }
      case EPayMethodType.HuifuChannelCasher:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.HuifuChannelCasher,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: unionPayInterUrl
          }), /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginTop: 8
            }
          }, t('settlement.payway.UnionPayaggregation')));
        }
      case EPayMethodType.HuifuAlipay:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.HuifuAlipay,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: alipayCN
          }), /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginTop: 8
            }
          }, t('settlement.payway.alipay')));
        }
      case EPayMethodType.HuifuWechat:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.HuifuWechat,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: weixinUrl
          }), /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginTop: 8
            }
          }, t('settlement.payway.Wechat pay')));
        }
      case EPayMethodType.Airwallex:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.Airwallex,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: CreditCardUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, t('settlement.payway.credit card')), /*#__PURE__*/React.createElement(ImgCardList, null, AirwallexCardList.map(function (item) {
            return /*#__PURE__*/React.createElement(ImgCardItem, {
              key: item.type,
              url: item.imgUrl
            });
          }))));
        }
      case EPayMethodType.FPX:
        {
          if ( /*#__PURE__*/React.isValidElement(FPXNode)) {
            return FPXNode;
          }
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.FPX,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: fpxPayUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, t('settlement.payway.fpx')), /*#__PURE__*/React.createElement(PayWithFPX, null)));
        }
      case EPayMethodType.XENDIT:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            id: "xendit__option",
            value: RadioPayMethod.XENDIT,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            id: "xendit__option--icon",
            url: xenditPayUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            id: "xendit__option--title",
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, t('settlement.payway.xendit'))));
        }
      case EPayMethodType.OneShip:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.OneShip,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: walletUrl
          }), /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginTop: 8
            }
          }, t('settlement.payway.oneshipwallet')));
        }
      case EPayMethodType.PayNow:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.PayNow,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: payNowUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, "PayNow")));
        }
      case EPayMethodType.UnionPayCard:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: RadioPayMethod.BindUnionCard,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: umsIconUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, t('settlement.payway.unionCardbindandpay'))));
        }
      case EPayMethodType.PayPal:
        {
          return /*#__PURE__*/React.createElement(RadioItem, {
            value: EPayMethodType.PayPal,
            key: item.payMethod,
            disabled: item.disabled
          }, /*#__PURE__*/React.createElement(Icon, {
            url: payPalUrl
          }), /*#__PURE__*/React.createElement(ContentWrap, null, /*#__PURE__*/React.createElement(Title3, {
            style: {
              marginRight: 12,
              marginTop: 8
            }
          }, "PayPal")));
        }
      default:
        {
          return null;
        }
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "xendit__box"
  }, payChannelList === null || payChannelList === void 0 ? void 0 : payChannelList.map(function (item) {
    if (item.payMethod === EPayMethodType.XENDIT) {
      return /*#__PURE__*/React.createElement(PayWithXendit, null);
    }
  })), footer && /*#__PURE__*/React.createElement(FooterWrap, null, footer)));
};
export var WrappedPayMethodCard = withI18nAndTheme(PayMethodCrad);
export default PayMethodCrad;